// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const buscarRepresentanteByCotaUsuarioService = async (
  cotaUsuarioId: number
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/representante/cotausuario/${cotaUsuarioId}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
};
